<template>
	<div>
		<cabecalho-pagina
			:key="cabecalhoKey"
			cor-background="white"
			cor-titulo="grey--text text--darken-2"
			cor-subtitulo="grey--text text--darken-1"
		>
			<template #actions>
				<div id="comboBotoesCabecalho" class="d-flex justify-space-evenly">
					<botao-processo-digital
						v-if="podeExibirBotaoProcessoDigital"
						class="efetivar-ata mr-5"
						:is-edocs="isIntegracaoEdocsAtivo"
						:is-ata-cancelada="isAtaCancelada"
						@acessar="visualizarProcessoDigital"
						@enviar-edocs="enviarEdocs"
						v-az-auth="permissoes.documentoProcessoDigitalVisualizar"
						cor-de-fundo="primary"
						cor-icone="primary"
					></botao-processo-digital>
					<botao-primario
						id="aderirAta"
						v-if="podeExibirBotaoAderirAta"
						outlined
						class="efetivar-ata mr-5"
						nome-botao="Aderir"
						cor-de-fundo="primary"
						@click="verificarSeExisteSomenteUmOrgao"
						v-az-auth="permissoes.ataAdesaoCriar"
					></botao-primario>
					<botao-primario
						v-if="estaEmElaboracao(informacoesAta) && temPermissaoEdicao"
						id="efetivarAta"
						outlined
						v-az-auth="permissoes.ataEfetivar"
						class="efetivar-ata mr-5"
						nome-botao="Efetivar Ata"
						cor-de-fundo="primary"
						@click="abrirOuFecharModalConfirmacaoEfetivarAta"
					></botao-primario>
					<botao-primario
						v-if="podeExibirBotaoAcessarPNCP"
						id="visualizarPncp"
						outlined
						class="efetivar-ata mr-5"
						nome-botao="Acessar PNCP"
						cor-de-fundo="primary"
						@click="acessarPncp"
					></botao-primario>
					<botao-manuseia-ata></botao-manuseia-ata>
				</div>
			</template>
			<template #situacao_icone>
				<icone-tooltip
					v-if="informacoesAta.isBloqueado"
					cor="red"
					:texto="informacoesAta.justificativaBloqueio"
					icone="mdi-cancel"
					tamanho="18"
				></icone-tooltip>
				<icone-tooltip
					v-if="isAtaCancelada"
					cor="error"
					:texto="informacoesAta.justificativaCancelamento"
					icone="mdi-close-circle-outline"
					tamanho="18"
				></icone-tooltip>
			</template>
			<template #numero_editando>
				<campo-editar-numero
					:exibir="exibirModalNumeroAtaEditando"
					:titulo="tituloModalNumeroAtaEditando"
					:rules="regrasNumeroAta"
					:situacao="informacoesAta.situacao"
					:situacoes-validas="['EM_ELABORACAO']"
					:numero-is-manual="numeroDaAtaIsManual"
					:is-ata-cancelada="isAtaCancelada"
					cor-subtitulo="grey--text text--darken-1"
					@abrir-ou-fechar-modal="abrirOufecharModalNumeroAtaEditando"
					@salvar-numero="salvarNumeroAta"
					@pode-exibir-acao="podeExibirAcaoEditar"
				></campo-editar-numero>
			</template>
		</cabecalho-pagina>
		<v-divider></v-divider>
		<az-container class="mt-0">
			<painel-com-tabs :abas="abas" ref="painelTabsRef"></painel-com-tabs>
		</az-container>
		<v-spacer></v-spacer>
		<modal-confirmacao
			id="idModalConfirmarEfetivar"
			:exibir="exibirModalConfirmar"
			:mensagem="getMensagemModalConfirmacaoEfetivacao()"
			@fechar-modal="abrirOuFecharModalConfirmacaoEfetivarAta"
			@confirmar="efetivarAta"
			:subtituloModal="subtituloModalConfirmar"
			:tituloModal="tituloModalConfirmar"
		></modal-confirmacao>
		<escoher-orgao-dominio
			:permissao-confirmar="permissoes.ataAdesaoCriar"
			:permissao-cancelar="permissoes.ataAdesaoItemExcluir"
			:exibir="exibirModalUoAderirAta"
			:orgaos="orgaos"
			titulo-modal="Aderir UO na Ata"
			subtitulo="Para qual órgão deseja aderir?"
			@fechar="fecharModalOrgaos"
			@buscar-orgaos="buscarOrgaosNaoAderidoNaAta"
			@orgao-selecionado="criarAderirAta"
		></escoher-orgao-dominio>
		<modal-edocs
			v-if="podeExibirModalEdocs"
			:id-processo-digital="idProcessoDigital"
			:exibir="exibirModalEdocs"
			@fechar-modal-edocs="fecharModalEdocs"
		></modal-edocs>
	</div>
</template>
<script>
import { actionTypes, getterTypes, mutationTypes, permissoes, routesNames } from '@/core/constants'
import BotaoManuseiaAta from '@/views/pages/ata/acessar/gestao-da-ata/cabecalho/BotaoManuseiaAta.vue'
import validacaoAta from '@/views/mixins/validacaoAta'
import { mapGetters, mapState } from 'vuex'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import CampoEditarNumero from '@/views/components/cabecalho/CampoEditarNumero.vue'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import EscoherOrgaoDominio from '@/views/pages/comum/escolher-orgao/EscolherOrgaoDominio.vue'
import { DataUtils } from '@/core/utils'
import TabRotaUtils from '@/core/utils/TabRotaUtils'
import BotaoProcessoDigital from '@/views/components/BotaoProcessoDigital.vue'
import ModalEdocs from '@/views/components/ModalEdocs.vue'

export default {
	name: 'gestao-da-ata-view',
	components: {
		ModalEdocs,
		BotaoProcessoDigital,
		EscoherOrgaoDominio,
		BotaoPrimario,
		CampoEditarNumero,
		BotaoManuseiaAta,
	},
	mixins: [validacaoAta, validacaoFormulario],
	provide() {
		return {
			idAta: this.$route.params.id,
			numeroDaAtaIsManual: this.$store.state.parametrosSistema.numeroDaAtaIsManual,
		}
	},
	data() {
		return {
			exibirModalConfirmar: false,
			exibirModalUoAderirAta: false,
			exibirModalNumeroAtaEditando: false,
			orgaos: [],
			tituloModalNumeroAtaEditando: 'Editar Número da Ata',
			subtituloModalConfirmar: 'Deseja realmente efetivar?',
			tituloModalConfirmar: 'Efetivar',
			regrasNumeroAta: [
				(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						30,
						'O campo do numero deve ser igual ou menor que 30 caracteres!',
					),
			],
			numeroDaAtaIsManual: this.$store.state.parametrosSistema.numeroDaAtaIsManual,
			isIntegracaoEdocsAtivo: this.$store.state.parametrosSistema.isIntegracaoEdocsAtivo,
			isProcessoDigitalAtivo: this.$store.state.parametrosSistema.isProcessoDigitalAtivo,
			isPermiteAdesao: false,
			exibirModalEdocs: false,
		}
	},
	computed: {
		...mapState({
			informacoesAta: (state) => state.ata.informacoesAta,
			cabecalhoKey: (state) => state.cabecalhoKey,
			isAtaEnviadaPncp: (state) => state.ata.informacoesAta.isEnviadaPncp
		}),
		...mapGetters({
			cabecalho: getterTypes.ATA.GET_ATA_PARA_CABECALHO,
		}),
		abas() {
			let abas = [
				new TabRotaUtils('Informações', routesNames.ATA.ATA_ACESSAR_INFORMACOES_VIEW),
				new TabRotaUtils('Itens', routesNames.ATA.ATA_ACESSAR_ITENS_VIEW),
				new TabRotaUtils('Documentos', routesNames.ATA.ATA_ACESSAR_DOCUMENTOS_VIEW),
			]

			if (this.temPermissaoVisualizarAcompanhamento) {
				abas.push(new TabRotaUtils('Acompanhamento', routesNames.ATA.ATA_ACESSAR_ACOMPANHAMENTO_VIEW))
			}

			if (this.isAtaEnviadaPncp) {
				abas.push(
					new TabRotaUtils(
						'Partes Envolvidas',
						routesNames.ATA.ATA_ACESSAR_PARTES_ENVOLVIDAS_VIEW,
						permissoes.ataParteEnvolvidaListar,
					),
				)
			}

			if (this.usuarioPodeVerAdesoesDoAderente || this.possuiAdesoesParaAnaliseDoGestor) {
				abas.push(
					new TabRotaUtils(
						'Adesões',
						routesNames.ATA.ATA_ACESSAR_MINHAS_ADESOES_VIEW,
						permissoes.ataAdesaoListar,
						'minhasAdesoesView',
					),
				)
			}

			abas.push(
				new TabRotaUtils(
					'Controle de Saldos - Órgão',
					routesNames.ATA.ATA_ACESSAR_CONTROLE_SALDO_ORGAO_VIEW,
					permissoes.ataAcompanhamentoSaldo,
				),
			)

			return abas
		},
		idProcessoDigital() {
			return this.$store.state.ata.informacoesAta.idProcessoDigital
		},
		isNaoVencido() {
			return !DataUtils.isVencido(this.$store.state.ata.informacoesAta.fimValidade)
		},
		podeExibirBotaoAcessarPNCP() {
			return this.isAtaEnviadaPncp
		},
		podeExibirBotaoProcessoDigital() {
			return (
				this.isProcessoDigitalAtivo &&
				(this.estaEfetivado(this.informacoesAta) || this.isAtaCancelada) &&
				!this.isAtaAdesao
			)
		},
		podeExibirBotaoAderirAta() {
			return (
				this.estaEfetivado(this.informacoesAta.situacao) &&
				this.orgaos.length > 0 &&
				this.isNaoVencido &&
				!this.isAtaAdesao &&
				this.isPermiteAdesao &&
				!this.isAtaCancelada
			)
		},
		podeExibirModalEdocs() {
			return this.isIntegracaoEdocsAtivo && this.exibirModalEdocs
		},
		isAtaCancelada() {
			return this.estaCancelada(this.informacoesAta.situacao)
		},
	},
	watch: {
		cabecalhoKey: {
			async handler() {
				await this.buscarOrgaosNaoAderidoNaAta()
			},
		},
	},
	async created() {
		this.$store.commit(mutationTypes.ITEM_PROCESSO.LIMPAR_FILTRO_LISTAGEM)
		if (!this.informacoesAta.id) await this.buscarAta()
		await this.atualizarInformacoesAta()
		this.resetarItensAtaSelecionados()
		await this.buscarOrgaosNaoAderidoNaAta()
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.LIMPAR_FILTRO_LISTAGEM)
		this.$store.commit(mutationTypes.ITEM_ATA.RESET_PAGINACAO_LISTAGEM)
	},
	methods: {
		async visualizarProcessoDigital() {
			const { url } = await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.VISUALIZAR_PROCESSO_DIGITAL,
				this.informacoesAta.id,
			)

			if (!url && this.isIntegracaoEdocsAtivo) {
				this.mostrarNotificacaoWarning(
					'Não é possível acessar o processo no e-Docs pois ainda não foi enviado nenhum documento.',
				)
				return
			}

			window.open(url, '_blank')
		},
		async carregarInformacoesDaAta() {
			await this.buscarAta()
			await this.atualizarInformacoesAta()
		},
		async buscarAta() {
			await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.$route.params.id)
		},
		async atualizarInformacoesAta() {
			await this.montaInformacoes()
			this.setFiltroItemProcesso()
			this.isPermiteAdesao = this.informacoesAta.isPermiteAdesao
		},
		montaInformacoes() {
			this.atualizaCabecalho(this.cabecalho)
		},
		atualizaCabecalho(informacoes) {
			this.$store.commit(mutationTypes.COMUM.SET_INFO_CABECALHO, informacoes)
		},
		setFiltroItemProcesso() {
			const idProcesso = this.$store.getters.informacoesAta.processo.id
			this.$store.commit(mutationTypes.ITEM_PROCESSO.SET_FILTRO_LISTAGEM, { idProcesso: idProcesso })
		},
		resetarItensAtaSelecionados() {
			this.$store.commit(mutationTypes.ITEM_ATA.LIMPAR_ITENS_PARA_ADICIONAR)
		},
		async efetivarAta() {
			await this.$store.dispatch(actionTypes.ATA.EFETIVAR_ATA, this.$route.params.id)

			this.mostrarNotificacaoSucesso('Ata efetivada com sucesso')
			this.abrirOuFecharModalConfirmacaoEfetivarAta()
			await this.carregarInformacoesDaAta()
			this.resetarItensAtaSelecionados()
			this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.ATUALIZAR_LISTAGEM)
			this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.ATUALIZAR_LISTAGEM_COM_TIMEOUT, 2000)
		},
		abrirOuFecharModalConfirmacaoEfetivarAta() {
			this.exibirModalConfirmar = !this.exibirModalConfirmar
		},
		async verificarSeExisteSomenteUmOrgao() {
			await this.buscarOrgaosNaoAderidoNaAta()
			if (this.orgaos.length === 1) {
				await this.criarAderirAta(this.orgaos[0].idOrgao)
				return
			}

			this.exibirModalUoAderirAta = true
		},
		fecharModalOrgaos() {
			this.exibirModalUoAderirAta = false
		},
		abrirOufecharModalNumeroAtaEditando() {
			this.exibirModalNumeroAtaEditando = !this.exibirModalNumeroAtaEditando
		},
		async salvarNumeroAta() {
			await this.$store.dispatch(actionTypes.ATA.SALVAR_NUMERO_ATA, {
				idAta: this.informacoesAta.id,
				numero: this.$store.state.campoEditarNumero.numero,
			})
			await this.$store.commit(mutationTypes.ATA.SET_NUMERO_ATA, this.$store.state.campoEditarNumero.numero)
			await this.montaInformacoes()
		},
		podeExibirAcaoEditar() {
			return this.temPermissaoEdicao && this.numeroDaAtaIsManual && this.estaEmElaboracao(this.informacoesAta)
		},
		async buscarOrgaosNaoAderidoNaAta() {
			if (this.informacoesAta.id) {
				const { itens } = await this.$store.dispatch(actionTypes.ADESAO.BUSCAR_ORGAOS, this.informacoesAta.id)
				this.orgaos = itens
			}
		},
		async criarAderirAta(orgaoSelecionado) {
			const data = await this.$store.dispatch(actionTypes.ADESAO.CRIAR_ADESAO, {
				idAta: this.informacoesAta.id,
				idOrgao: orgaoSelecionado,
			})
			this.fecharModalOrgaos()
			this.mostrarNotificacaoSucessoDefault()
			await this.redirecionarParaListagem(data.id)
		},
		async redirecionarParaListagem(idAdesao) {
			await this.$router.push({
				name: routesNames.ADESAO.ADESAO_VIEW,
				params: { id: idAdesao, tipoAcesso: 'editar' },
			})
		},
		getMensagemModalConfirmacaoEfetivacao() {
			if (this.possuiDocumentoTipoAtaRegistroPrecoNaoAssinado) {
				return 'Atenção! O documento da Ata está sem assinatura e será enviado ao PNCP. Essa é uma ação permanente!'
			}
			return ''
		},
		acessarPncp() {
			const urlPncp = this.$store.getters.informacoesAta.urlPncp
			this.redirecionarPara(urlPncp)
		},
		redirecionarPara(url) {
			window.open(url, '_blank')
		},
		enviarEdocs() {
			this.exibirModalEdocs = true
		},
		fecharModalEdocs() {
			const painelTabsRef = this.$refs.painelTabsRef
			if (this.$route.name === routesNames.ATA.ATA_ACESSAR_DOCUMENTOS_VIEW) {
				painelTabsRef.$refs.childRef.buscarDocumentos()
			}

			this.exibirModalEdocs = false
		},
	},
}
</script>
<style scoped lang="stylus">

#efetivarAta
	font-size: 12px !important;
</style>
